import React from "react";
import { Form, Tab, Tabs } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import TinyEditor from "@components/Editor";

import getReminderInterval from "@SiteManagement/PaymentReminders/lib/getReminderInterval";
import {
    PaymentReminder,
    PaymentRemindersForm,
} from "@SiteManagement/PaymentReminders/types/paymentreminders";

const PaymentReminderTabs = ({
    paymentReminders,
}: {
    paymentReminders: Array<PaymentReminder>;
}): React.JSX.Element => {
    const methods = useFormContext<PaymentRemindersForm>();

    return (
        <Tabs
            id="paymentReminders"
            data-testid="paymentRemindersContent"
            defaultActiveKey={getReminderInterval(
                paymentReminders[0]?.template_key ?? "",
            )}
        >
            {paymentReminders.map(reminder => {
                const interval = getReminderInterval(reminder.template_key);
                return (
                    <Tab
                        eventKey={interval}
                        title={reminder.template_name}
                        key={reminder.template_key}
                    >
                        <Form.Control
                            type="hidden"
                            {...methods.register(interval)}
                        />
                        <TinyEditor
                            editorValue={methods.watch(
                                interval,
                                methods.getValues(interval),
                            )}
                            formField={interval}
                            formMethods={methods}
                        />
                    </Tab>
                );
            })}
        </Tabs>
    );
};

export default PaymentReminderTabs;
